import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    height: 'calc(100vh - 150px)',
  },
}))
